module.exports = __webpack_public_path__ + "img/resources-article-mens-exercises@1x.29469f3a.jpg";